export enum QuestionType {
  Input,
  Score,
  Radio
}
